import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderDelete: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderDelete"><Path d="M2.5 11.5V3.5H10L12 6.5H21.5V19.5H10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 14.5L5 17L2.5 19.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M2.5 14.5L5 17L7.5 19.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFolderDelete;
